import styled from 'styled-components'

import { FieldSkeleton } from '@/components/layout/field-row'
import { DetailsListItem } from '@/components/ui/details-list'

// Note: the skeleton fills the whole row instead of shrinking to the value's width
export const SkeletonRow = styled(DetailsListItem)({
  '& > span': {
    flex: 1,
    minWidth: 0,
  },
})

// Note: sits inside a title's text line
export const CountSkeleton = styled(FieldSkeleton)(({ theme }) => ({
  display: 'inline-block',
  marginLeft: theme.space['6'],
  verticalAlign: 'middle',
}))
